import React, { useState } from 'react'
import moment from 'moment'
import { reduxForm } from 'redux-form'
import CamposCargaBuque from './CamposCargaBuque'
import { FORM_BUQUES } from '../../../../config/forms'

function EdicionDetalleCarga (props) {
  const { data, change: formChange } = props
  const [init, setInit] = useState(false)

  async function getData () {
    const { change: formChange } = props
    const exportador = `${data.nombreExportador} - ${data.exportador}`
    formChange('fechaAnuncio', data.fechaAnuncio)
    formChange('fechaCarga', data.fechaDeCarga)
    formChange('fechaCargaOld', data.fechaDeCarga)
    formChange('cereal', data.claveCereal)
    formChange('cerealOld', data.claveCereal)
    formChange('exportador', exportador)
    formChange('exportadorOld', exportador)
    formChange('toneladas', data.toneladas)
  }

  if (data && !init) {
    getData()
    setInit(true)
  }

  const actualizarFechas = (fecha) => {
    formChange('fechaCarga', moment(fecha).format('YYYY-MM-DD'))
  }

  return (
    <div style={{ padding: '2%' }}>
      <CamposCargaBuque actualizarFechas={actualizarFechas} detalleInicial={data} actualizacion />
    </div>
  )
}

const withReduxForm = reduxForm({
  form: FORM_BUQUES
})

export default withReduxForm(EdicionDetalleCarga)
